import { useMutation } from "@tanstack/react-query";
import {
	type FinancialBalanceLeadRequestDTO,
	postLeadFinancialBalanceV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useLeadMutation = () => {
	return useMutation({
		mutationFn: processResponse(
			(requestContract: FinancialBalanceLeadRequestDTO) =>
				postLeadFinancialBalanceV2(requestContract),
		),
	});
};
